import debounce from 'lodash/debounce';

const ResizeSensor = require('./ResizeSensor.js');

;(function($, window, document, undefined) {

  const pluginName = 'stick';

  class Stick {

    constructor(element, options) {

      this._defaults = $.fn[pluginName].defaults;
      this._name = pluginName;

      this.element = element;
      this.options = $.extend({}, this._defaults, options);

      this.init();

    }

    init() {

      this.cacheElements();

      let wrapper = $('<div data-stick-wrapper>').css({
        position: 'static',
        minHeight: this.$element.outerHeight(true)
      });

      this.$element.wrap(wrapper);

      this.$wrapper = this.$element.closest('[data-stick-wrapper]');

      this.scrollListener = debounce(this.stick.bind(this), this.options.scrollDebounce);

      this.resetRange();
      this.bindEvents();
      this.stick();

    }

    _stickRange() {
      this.$element
        .addClass('stick')
        .css({
          position: 'fixed',
          top: this.options.offset,
          bottom: 'auto'
        });
    }

    _stickBottom() {
      this.$element
        .css({
          position: 'absolute',
          bottom: 0,
          top: 'auto'
        });
    }

    _unstick() {
      this.$element
        .removeClass('stick')
        .css({
          position: 'static',
          bottom: 'auto',
          top: 'auto'
        });
    }

    setRangeBegin() {
      setTimeout(function() {
        this.rangeBegin = this.$wrapper.offset().top - this.options.offset;
      }.bind(this), 0);
    }

    setRangeEnd() {
      if (this.$container[0]) {
        this.limit = this.$container.offset().top + this.$container.height();
        this.rangeEnd = this.limit - this.$element.outerHeight(true) - this.options.offset;
      }
    }

    resetRange() {
      this.setRangeBegin();
      this.setRangeEnd();
    }

    cacheElements() {
      this.$element = $(this.element);
      this.$container = this.options.container || this.$element.closest('[data-stick-container]');
    }

    bindEvents() {

      $(window).on('scroll', this.scrollListener);

      new ResizeSensor($('body')[0], this.resetRange.bind(this));

      $.map(this.options.watch, function(el) {
        new ResizeSensor(el[0], this.resetRange.bind(this));
      }.bind(this));

    }

    stick() {

      var scrollTop = $(window).scrollTop();

      if (this.$container[0]) {

        if (scrollTop >= this.rangeEnd) {
          this._stickBottom();
        } else if (scrollTop > this.rangeBegin && scrollTop < this.rangeEnd) {
          this._stickRange();
        } else if (scrollTop <= this.rangeBegin) {
          this._unstick();
        }

      } else {

        if (scrollTop > this.rangeBegin) {
          this._stickRange();
          return;
        } else {
          this._unstick();
        }

      }

    }

  }

  $.fn[pluginName] = function(options) {

    var args = arguments;

    if (options === undefined || typeof options === 'object') {
      return this.each(function() {
        if (!$.data(this, `plugin_${pluginName}`)) {
          $.data(this, `plugin_${pluginName}`, new Stick(this, options));
        }
      });

    } else if (typeof options === 'string' && options[0] !== '_') {

      var returns;

      this.each(function() {

        var instance = $.data(this, `plugin_${pluginName}`);

        if (instance instanceof Stick && typeof instance[options] === 'function') {
          returns = instance[options].apply(instance, Array.prototype.slice.call(args, 1));
        }

      });

      return returns !== undefined ? returns : this;

    }

  };

  $.fn[pluginName].defaults = {
    watch: [],
    scrollDebounce: 5,
    offset: 0
  };

})(jQuery, window, document);
